import * as React from 'react';
import { useDatasheetController } from "./datasheet/main";
import { useFieldsController } from "./fields";
import { useDatasheetPrintController } from '../../../controllers/datasheet-print';
import { DatasheetLocalGetDto } from '../types/datasheet';
import { PRINTABLE_EDITOR_DATASHEET_ELEMENT_ID, PRINTABLE_DATASHEET_FIELD_ID } from '../../datasheet-printing-settings';
import { generateId } from '@common/utils/common';

export type EditorProps = {

};

export const useEditorController = (props: EditorProps) => {
  const [datasheet, setDatasheet] = React.useState<DatasheetLocalGetDto>({
    id: 1,
    name: 'Test Datasheet',
    tabs: Array.from(Array(3)).map((_, index) => ({ id: index+1, name: 'Tab '  + index, texts: [], fields: [] })),
    gridSettings: {
      horizontalGrid: 30,
      verticalGrid: 30,
      showGrid: true,
      showPageBreaks: false,
      snapToGrid: true,
      showEditTabOrder: false,
      showMargins: false,
      marginWidth: 400,
      marginHeight: 300,
    },
  });

  const fieldsController = useFieldsController();
  const printableDatasheetHolderId = React.useMemo(() => `${PRINTABLE_EDITOR_DATASHEET_ELEMENT_ID}-${generateId()}`, []);

  const datasheetPrintController = useDatasheetPrintController({
    printableDatasheetHolderId: printableDatasheetHolderId,
    printableDatasheetFieldId: PRINTABLE_DATASHEET_FIELD_ID
  });

  const editorController = useDatasheetController({
    selectedFieldsInFieldPicker: fieldsController.selectedFieldsInFieldPicker,
    datasheet,
    onDatasheetChange: setDatasheet,
  });

  return {
    datasheet,
    printableDatasheetHolderId,
    ...editorController,
    ...fieldsController,
    ...datasheetPrintController,
  };
};